import React from 'react';
import PropTypes from 'prop-types';
import { uiConfig } from '../../../../../conf/listItems';

// Components
import Form from '../../../../../../components/Form';
import { DialogBody } from '../../../../../../components/DialogBody';
import { DialogFooter } from '../../../../../../components/DialogFooter';
import { Button } from '../../../../../../components/Button';

// Utils
import { translateUIConfigForAddEdit, translateFormDataForReadOnlyForm } from '../../../../../../common/utility';

export const ListItemReadOnlyForm = ({ data, closeDialog }) => {
    const documentState = React.useMemo(() => {
        if (data) {
            return translateFormDataForReadOnlyForm({ uiConfig, data });
        } else {
            return typeof uiConfig.newDoc === 'object' ? uiConfig.newDoc : {};
        }
    }, [data]);

    const formModel = translateUIConfigForAddEdit(uiConfig);
    const onApplyFormState = () => {};

    return (
        <>
            <DialogBody>
                <Form
                    formModel={formModel}
                    data={documentState}
                    errors={{}}
                    compose={false}
                    onApplyFormState={onApplyFormState}
                    setEdited={() => {}}
                    fatalError={null}
                />
            </DialogBody>
            <DialogFooter>
                <Button text appearance="secondary" onClick={closeDialog}>
                    Cancel
                </Button>
            </DialogFooter>
        </>
    );
};

export default ListItemReadOnlyForm;

ListItemReadOnlyForm.propTypes = {
    data: PropTypes.object,
    closeDialog: PropTypes.func
};
